import { type FC } from 'react'

import { ListingReportButton } from '@/features/listing/components/report/ListingReportButton'

export type ListingReportProps = {
  /**
   * Specifies if it is a MoVe listing
   */
  isMoveListing: boolean

  /**
   * Specifies if it is a seller vip
   */
  isSellerVip: boolean
}

/**
 * Wrapper component for the report feature, managing modal states.
 *
 * This component is responsible for rendering the report button and the modal.
 * It manages the modal state and passes the listing ID to the modal.
 *
 * To use a custom trigger, use the `ListingReportModal` components directly.
 * ```
 * const [isModalOpen, setIsModalOpen] = useState(false)
 * <ListingReportModal listingId={listingId} isOpen={isModalOpen} />
 * // Use a custom trigger to open the modal with setIsModalOpen(true)
 * ```
 */
export const ListingReport: FC<ListingReportProps> = ({ isMoveListing, isSellerVip }) => {
  if (isSellerVip || isMoveListing) return null

  return <ListingReportButton />
}
